import React from "react";
import { Button } from "@material-ui/core";
import { TableCell, Typography } from "@material-ui/core";
import { localizer } from '../../../Translator'
import { Link } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Grid, Backdrop, CircularProgress } from "@material-ui/core"

import { TableRowStyled } from '../../common/TableStyled.js'

import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send'
import DateCustom from "../../Utilities/DateCustom";

import { ImageViewer } from "../../Utilities/ImageViewer";

/**
 * Class component that represents a draft 
 * as a row into the drafts list table.
 */
export class DraftRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openDraftModal: false,
      openDeleteDraftModal: false,
      draft: {},
      pageIndex: 1,
      pageBase64: "",
      isLoading: false,
      // Attributes to determinate when a draft is loaded in loadeddialog component.
      isLoadingDraft: false,
    }
  }

  componentDidMount() {
    this.setState({ draft: this.props.draft })
  }

  /**
   * Deletes an existing draft.
   * It's called when the user press 'Remove draft' button. 
   */
  deleteItem = (event) => {
    this.props.deleteDraft(this.state.draft.draftId)
    this.handleCloseDraftModal()
  }

  /**
   * Handling of both open an close draft's preview dialog.
   */
  handleOpenDraftModal = () => {
    this.setState({ openDraftModal: true, isLoadingDraft: true })
  }
  
  handleCloseDraftModal = () => {
    this.setState({ openDraftModal: false })
  }

  handleCloseDeleteDraftModal = () => {
    this.setState({ openDeleteDraftModal: false })
  }

  handleOpenDeleteDraftModal = () => {
    this.setState({ openDeleteDraftModal: true })
  }
 
  handleisLoadingDraft = () => {
    this.setState({ isLoadingDraft: false })
  }
  
  render() {
    return (
      <React.Fragment>
        <TableRowStyled>
          <TableCell className="typography-generic tablerow-content">{this.state.draft.documentName}</TableCell>
          <TableCell className="typography-generic tablerow-content">{this.state.draft.description}</TableCell>
          <TableCell className="typography-generic tablerow-content">{DateCustom.formatDate(this.state.draft.uploadTime)}</TableCell>
          <TableCell className="typography-generic tablerow-content">{this.state.draft.ownerUser}</TableCell>
          <TableCell className="typography-generic tablerow-content">{this.state.draft.timesUsed}</TableCell>
          <TableCell>
            <IconButton className="button-generic icon-button" aria-label="Visibility" onClick={this.handleOpenDraftModal} >
              <i className="fa-solid fa-eye"></i>
            </IconButton>
          </TableCell>
          <TableCell>
            <Link to={"/shipment?draftCode=" + this.state.draft.draftId}>
              <IconButton className="button-generic icon-button" aria-label="shipment" onClick={this.handleOpenShipmentModal}>
                <SendIcon fontSize="inherit"></SendIcon>
              </IconButton>
            </Link>
          </TableCell>
          <TableCell>
            {this.state.draft.timesUsed !== 0 ?
              <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.InfoDontRemove}</Typography>}>
                <div>
                  <IconButton className="button-generic icon-button" disabled="true" aria-label="Delete" onClick={this.handleOpenDeleteDraftModal}>
                    <i className="fa-solid fa-trash-can"></i>
                  </IconButton>
                </div>
              </Tooltip> :
              <IconButton className="button-generic icon-button" aria-label="Delete" onClick={this.handleOpenDeleteDraftModal}>
                <i className="fa-solid fa-trash-can"></i>
              </IconButton>
            }
          </TableCell>
        </TableRowStyled>

        <Dialog
          open={this.state.openDraftModal}
          onClose={this.handleCloseDraftModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseDraftModal}></i>
            <Typography className="typography-generic dialog-title">{localizer.DocumentPreview}</Typography>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <ImageViewer
              documentid={this.state.draft.draftId}
              pagenumber={this.state.pageIndex}
              totalpages={this.state.draft.pages}
              viewerWidth={600}
              viewerHeight={700}
              getCurrentPage={() => { }}
              handleisLoadingDraft={this.handleisLoadingDraft}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          open={this.state.openDeleteDraftModal}
          onClose={this.handleCloseDeleteDraftModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseDeleteDraftModal}></i>
            <Typography className="typography-generic dialog-title">{localizer.DeleteDraft}</Typography>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row" spacing={4} className="mt-10">
              <Grid container item md={12} direction="row" spacing={2}>
                <Typography className="typography-generic">{localizer.DeleteDraftConfirmation} {this.state.draft.documentName}?</Typography>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseDeleteDraftModal}>{localizer.Cancel}</Button>
                <Button className="button-generic dialog-delete" variant="contained" style={{ float: 'right' }} onClick={this.deleteItem}>{localizer.Delete}</Button>
              </Grid>
            </Grid>
          </DialogContent>
          {/* <DialogFooterCenter>
            <Button className="button-generic dialog-secondary" variant="contained" onClick={this.handleCloseDeleteDraftModal}>{localizer.Cancel}</Button>
            <Button className="button-generic dialog-primary" variant="contained" onClick={this.deleteItem}>{localizer.Accept}</Button>
          </DialogFooterCenter> */}
        </Dialog>
        
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} className="zindex-1350">
            <CircularProgress color="secondary" />
          </Backdrop>
        }
        {/* Waiting for draft is loaded. */}
        {this.state.isLoadingDraft &&
          <Backdrop open={this.state.isLoadingDraft} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drafts/sections/DraftRow.js